import { render, staticRenderFns } from "./modelling.vue?vue&type=template&id=1c5d146d&"
import script from "./modelling.vue?vue&type=script&lang=js&"
export * from "./modelling.vue?vue&type=script&lang=js&"
import style0 from "./modelling.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports